import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { LayoutPlain, Header, Footer } from 'components/layout'
import { meta } from 'helpers/decorators'
import { Button, Module } from '../../../components/misc'
import { FormattedMessage } from 'react-intl'
import queryString from 'query-string'
import { get } from 'lodash'
import { apiAssessors } from '../../../helpers/decorators/api'
import { LoaderOverlay } from '../../../components/loaders'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'


@meta({ title: 'Accept activity', intlKey: 'route.accept_activity' })
@apiAssessors()
@connect(
  state => ({
    isSubmitting: get(state, 'api.assessor.assessors.loading'),
    submitted: get(state, 'api.assessor.assessors.loaded')
  }),
  { push }
)
class AcceptActivity extends Component {
  static propTypes = {
    location: PropTypes.object,
    acceptActivityByLink: PropTypes.func,
    isSubmitting: PropTypes.bool,
    submitted: PropTypes.bool
  }

  componentDidMount() {
    const query = queryString.parse(this.props.location.search)

    this.props.acceptActivityByLink(get(query, 'authorizationCode'))
  }

  render() {
    const { isSubmitting, submitted } = this.props

    return (

      <LayoutPlain
        header={<Header />}
        footer={<Footer />}
        body={[<Module>
          <LoaderOverlay isLoading={isSubmitting}>
              <h2 className="alpha nowrap">
                <FormattedMessage
                  id="moduleTitle.accept_activity"
                  defaultMessage="Accept Activity"
                />
              </h2>
                <div>
                  {submitted && <p className="delta text--left">
                    <FormattedMessage
                      id="notifications.activity_was_accepted"
                      defaultMessage="Activity was accepted"
                    />
                  </p>}
                  <Button
                    type="button"
                    onClick={this.redirectToLogin}
                    simple
                    fluid
                  >
                    <FormattedMessage
                      id="moduleTitle.login"
                      defaultMessage="Log in"
                    />
                  </Button>
                </div>
        </LoaderOverlay>
        </Module>]}
        colWidth="305px"
      />

    )
  }
}

export default AcceptActivity
